import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const FAQSection = () => {
  const faqs = [{
    question: "What is this launch offer and how does it work?",
    answer: "The new starter plan is priced at ₹2470, but under this promotional launch offer, it is being made available at ₹149 per month to be paid manually by the customer. This special price may be changed or completely withdrawn anytime."
  }, {
    question: "Is this a recurring payment? How do I cancel?",
    answer: "Yes. Your plan will automatically renew depending on your plan frequency. You can cancel the subscription from your UPI app or write to us at support@cutshort.io if you need help."
  }, {
    question: "Can recruitment agencies or staffing companies buy Starter plan?",
    answer: "Not currently. Please don't purchase this plan if you are a recruitment agency or a staffing company."
  }, {
    question: "Can I pay with a credit card or net banking?",
    answer: "Yes. Click the button above to pay securely via Razorpay."
  }, {
    question: "Will I get a GST invoice?",
    answer: "Yes. Please provide your GST number during the payment process. Revision of invoices to update GST number will not be possible after the payment is made."
  }];
  return <section className="py-16 bg-secondary">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-4">Got questions?</h2>
          </div>

          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => <AccordionItem key={index} value={`item-${index}`} className="bg-background border border-border rounded-lg px-6">
                <AccordionTrigger className="text-left font-semibold text-foreground hover:no-underline py-6">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
};
export default FAQSection;


